import { useNav } from "./components/NavContext";

// Bg components (maybe interactive later)
import bgImage from "./assets/UI/night sky.png"; 
import buildingLeft from "./assets/UI/building left.png";
import buildingRight from "./assets/UI/building right.png";
import cityImage from "./assets/UI/city.png";



export default function Art() {
  // Return button
  const handleNav = useNav();
  // The background 
return (
    <div
      className="relative h-screen w-screen bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/UI/night sky.png')" }} 
    >
      <div className="absolute top-4 left-4 z-20">
        <button
          onClick={handleNav("/")}
          className="px-4 py-2 bg-gray-800 text-green-700 rounded-xl shadow-lg hover:bg-black transition cursor-pointer"
        >
          Return to Main Page
        </button>
      </div>

      <img
        src={buildingLeft}
        alt="Build Left"
        className="absolute bottom-0 left-0 w-96 h-auto pointer-events-none"
      />

      <img
        src={buildingRight}
        alt="Build Right"
        className="absolute bottom-0 right-0 w-96 h-auto pointer-events-none"
      />

      <img
        src={cityImage} 
        alt="City"
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-64 h-auto pointer-events-none"
      />

      {/* Center content */}
      <div className="flex flex-col justify-center items-center h-full text-white text-2xl relative z-10">
        <p className="font-bold drop-shadow-md mb-8">My Art</p>
        {/* We can put your new Hearthstone-style cards here later! */}
      </div>
    </div>
  );
}